const Heading = (props) => <h1 className="Heading">{props?.headingData?.text}</h1>;

export default Heading;
